import { ActionDate } from "./action-date.model";
import { ContactTypeEnum } from "../common/enums/ContactTypeEnum";

export interface JournalType {
  readonly journalEntryContainers: Array<JournalEntryContainerType>;
  readonly journalEntries: {
    [journalEntryContainerId: number]: Array<JournalEntryType>;
  };
  readonly journalEntryItems: Array<JournalEntryItemType>;
  readonly processedIds: Array<number>;
}

export class Journal implements JournalType {
  readonly journalEntryContainers: Array<JournalEntryContainerType>;
  readonly journalEntries: {
    [journalEntryContainerId: number]: Array<JournalEntryType>;
  };
  readonly journalEntryItems: Array<JournalEntryItemType>;
  readonly processedIds: Array<number>;

  constructor() {
    this.journalEntryContainers = [];
    this.journalEntries = {};
    this.journalEntryItems = [];
    this.processedIds = [];
  }
}

export interface JournalEntryContainerType {
  readonly id: number;
  readonly authorId: number;
  readonly type: ContactTypeEnum;
  readonly actionDate: ActionDate;
}

export class JournalEntryContainer implements JournalEntryContainerType {
  readonly id: number;
  readonly authorId: number;
  readonly type: ContactTypeEnum;
  readonly actionDate: ActionDate;

  constructor(
    id: number,
    authorId: number,
    type: ContactTypeEnum,
    actionDate: ActionDate
  ) {
    this.id = id;
    this.authorId = authorId;
    this.type = type;
    this.actionDate = actionDate;
  }
}

export interface JournalEntryType {
  readonly containerId: number;
  readonly title: string;
  readonly authorId: number;
  readonly actionDate: ActionDate;
  readonly journalEntryTypes: Array<string>;
  readonly journalEntryItems: Array<number>;
}

export class JournalEntry implements JournalEntryType {
  readonly containerId: number;
  readonly title: string;
  readonly authorId: number;
  readonly actionDate: ActionDate;
  readonly journalEntryTypes: Array<string>;
  readonly journalEntryItems: Array<number>;

  constructor(
    containerId: number,
    title: string,
    authorId: number,
    actionDate: ActionDate,
    journalEntryItems: Array<JournalEntryItemType>
  ) {
    this.containerId = containerId;
    this.title = title;
    this.authorId = authorId;
    this.actionDate = actionDate;

    const journalEntryIds: Array<number> = [];
    const journalEntryTypes: Array<string> = [];

    journalEntryItems.forEach(entryItem => {
      journalEntryIds.push(entryItem.id);

      if (journalEntryTypes.indexOf(entryItem.type) < 0) {
        journalEntryTypes.push(entryItem.type);
      }
    });
    this.journalEntryItems = journalEntryIds;
    this.journalEntryTypes = journalEntryTypes;
  }
}

export interface JournalEntryItemType {
  readonly id: number;
  readonly type: string;
  readonly title: string;
  readonly statusKey: string;
}

export class JournalEntryItem implements JournalEntryItemType {
  readonly id: number;
  readonly type: string;
  readonly title: string;
  readonly statusKey: string;

  constructor(id: number, type: string, title: string, statusKey: string) {
    this.id = id;
    this.type = type;
    this.title = title;
    this.statusKey = statusKey;
  }
}
